var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle-banner text-center"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('img',{attrs:{"src":require("../assets/img/img_sofashionsoeasy.svg"),"alt":""}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }